<template>
  <div class="cart mt40">
    <!-- 我的购物车 -->
    <div class="cart-wrap">
      <div class="title">我的购物车</div>
      <!-- 购物车信息 -->
      <div class="cart-info">
        <div class="row row-header">
          <div class="row-item wid">
            <!-- <el-checkbox v-model="allChecked" @change="handleCheckAll">全选</el-checkbox> -->
            <div class="goods-name">商品</div>
          </div>
          <div class="row-item">规格</div>
          <div class="row-item">单价</div>
          <div class="row-item">数量</div>
          <div class="row-item">优惠金额</div>
          <div class="row-item">金额</div>
          <div class="row-item">操作</div>
        </div>
        <!-- 商品信息 -->
        <div class="store-list">
          <div v-for="(item, index) in list" :key="index" class="store-item">
            <div class="store-name">
              <el-checkbox v-model="item.checked" @change="checkStoreGoods($event, item)"></el-checkbox>
              {{item.industryName}}
            </div>
            <div class="goods-list">
              <div v-for="(goods, ind) in item.goodsList" :key="ind" class="row">
                <div class="row-item wid">
                  <el-checkbox v-model="goods.selected" @change="checkGoods($event, goods, item)"></el-checkbox>
                  <div class="left">
                    <img :src="goods.goodsTargetThumbnail" alt="">
                  </div>
                  <div class="right">
                    {{goods.goodsTargetName}}
                  </div>
                </div>
                <div class="row-item">
                  <!-- <span class="label">颜色:</span> -->
                  <span class="val">{{goods.attributes}}</span>
                </div>
                <div class="row-item">￥{{goods.goodsPrice}}</div>
                <div class="row-item">
                  <img v-if="goods.quantity <= 1" class="control disabled" src="../../assets/images/dec-qty-nagt.png" alt="">
                  <img v-else class="control" src="../../assets/images/dec-qty.png" alt="" @click="handleDecQty(goods)">
                  <span class="qty">{{goods.quantity}}</span>
                  <img v-if="goods.quantity >= goods.availableStock" class="control disabled" src="../../assets/images/add-qty-nagt.png" alt="">
                  <img v-else class="control" src="../../assets/images/add-qty.png" alt="" @click="handleAddQty(goods)">
                </div>
                <div class="row-item">{{goods.coupon == null ? '暂无' : '￥' + goods.coupon}}</div>
                <div class="row-item">￥{{goods.subtotal}}</div>
                <div class="row-item"><span class="single-delete" @click="handleSingleRemove(goods)">删除</span></div>
              </div>
            </div>
          </div>
          <div v-if="inValidList.length > 0" class="invalid-goods">失效商品({{inValidList.length}}件)</div>
          <div v-for="(item, index) in inValidList" :key="index" class="store-item">
            <div class="store-name">
              <!-- <el-checkbox v-model="item.checked" @change="checkStoreGoods($event, item)"></el-checkbox> -->
              {{item.industryName}}
              <a class="remove-btn blue" @click="handleRemoveGoods('invalid', item)">清除失效商品</a>
            </div>
            <div class="goods-list">
              <div v-for="(goods, ind) in item.goodsList" :key="ind" class="row">
                <div class="row-item wid">
                  <el-checkbox v-model="goods.selected" :disabled="true" @change="checkGoods($event, goods, item)"></el-checkbox>
                  <div class="left">
                    <img :src="goods.goodsTargetThumbnail" alt="">
                  </div>
                  <div class="right">
                    {{goods.goodsTargetName}}
                  </div>
                </div>
                <div class="row-item">
                  <!-- <span class="label">颜色:</span> -->
                  <span class="val">{{goods.attributes}}</span>
                </div>
                <div class="row-item">￥{{goods.goodsPrice}}</div>
                <div class="row-item">
                  <img v-if="goods.quantity <= 1" class="control disabled" src="../../assets/images/dec-qty-nagt.png" alt="">
                  <img v-else class="control" src="../../assets/images/dec-qty.png" alt="" @click="handleDecQty(goods)">
                  <span class="qty">{{goods.quantity}}</span>
                  <img v-if="goods.quantity >= goods.availableStock" class="control disabled" src="../../assets/images/add-qty-nagt.png" alt="">
                  <img v-else class="control" src="../../assets/images/add-qty.png" alt="" @click="handleAddQty(goods)">
                </div>
                <div class="row-item">{{goods.coupon == null ? '暂无' : '￥' + goods.coupon}}</div>
                <div class="row-item">￥{{goods.subtotal}}</div>
                <div class="row-item"><span class="single-delete" @click="handleSingleRemove(goods)">删除</span></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 底部合计信息 -->
    <div class="sum-info">
      <div class="inner">
        <div class="left">
          <!-- <el-checkbox v-model="allChecked" @change="handleCheckAll">全选</el-checkbox> -->
          <a class="a-btn" @click="handleBatchRemove">删除选中的宝贝</a>
          <a class="a-btn" @click="handleRemoveGoods('invalid')">清除失效产品</a>
        </div>
        <div class="right">
          <span>已选商品</span>
          <span class="num"><em>{{totalNum}}</em>件</span>
          <span class="total">总金额: </span>
          <span class="amount">¥ <em>{{totalAmount}}</em></span>
          <el-button class="red-btn" @click="handleToBuy">立即购买</el-button>
        </div>
      </div>
    </div>
    <!-- 弹窗提示 -->
    <div class="shadow" :class="showpop ? '' : 'hide'">
      <div class="container">
        <div class="close"><img src="../../assets/images/close.png" alt="" @click="showpop = false"></div>
        <div class="title">删除宝贝</div>
        <div class="text">确定要删除{{singleRemove ? '改' : '这些'}}宝贝吗？</div>
        <div class="btns">
          <el-button @click="showpop = false">关闭</el-button>
          <el-button @click="handleRemoveGoods">确定</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { loadList, removeGoods, removeCart, updateCart, calAmount } from '@/api/retail/cart'
import { config } from '@/constant/config'
import { mapState } from 'vuex'
export default {
  data () {
    return {
      totalAmount: 0,
      totalNum: 0,
      list: [],
      inValidList: [],
      showpop: false,
      singleRemove: false
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.userInfo || {}
    }),
    allChecked () {
      const selected = this.list.filter(store => store.checked)
      let allChecked = false
      if (selected.length > 0 && selected.length === this.list.length) {
        allChecked = true
      } else {
        allChecked = false
      }
      return allChecked
    },
    selectedStoreIds () {
      const selected = this.list.filter(store => store.checked)
      return selected.map(item => item.industryId)
    }
  },
  created () {
    this.loadList()
  },
  methods: {
    // 加载购物车
    loadList () {
      loadList(this.userInfo.merchId).then(res => {
        if (res.code === 0) {
          const list = []
          this.$store.dispatch('setcartNum', res.data.cartItems.length)
          res.data.cartItems.forEach(item => {
            if (this.originSelectedStoreIds && this.originSelectedStoreIds.some(store => store === item.industryId)) {
              item.checked = true
            } else if (this.originSelectedGoodsIds && this.originSelectedGoodsIds.some(goods => goods === item.goodsTargetId)) {
              item.selected = true
            } else {
              item.checked = false
              item.selected = false
            }
            const index = list.findIndex(store => store.industryId === item.industryId)
            if (index >= 0) {
              // 店铺已存在
              list[index].goodsList.push(item)
            } else {
              // 店铺尚未存在
              const obj = JSON.parse(JSON.stringify(item))
              obj.goodsList = [item]
              list.push(obj)
            }
          })
          this.list = list
          const inValidList = []
          res.data.invalidCartItems.forEach(item => {
            const index = inValidList.find(store => store.industryId === item.industryId)
            if (index >= 0) {
              // 店铺已存在
              inValidList[index].goodsList.push(item)
            } else {
              // 店铺尚未存在
              item.goodsList = [item]
              inValidList.push(item)
            }
          })
          this.inValidList = inValidList
        } else {
          this.$message.error(res.error)
        }
      })
    },
    // 全选
    handleCheckAll (val) {
      this.list.forEach(item => {
        item.checked = val
        item.goodsList.forEach(goods => {
          goods.selected = val
        })
      })
      this.calAmount()
    },
    // 店铺选中改变
    checkStoreGoods (e, item) {
      item.goodsList.forEach(goods => {
        goods.selected = e
      })
      this.calAmount()
    },
    // 商品选中改变
    checkGoods (e, goods, item) {
      if (item.goodsList.some(goodsItem => !goodsItem.selected)) {
        item.checked = false
      } else {
        item.checked = true
      }
      this.list = this.list.concat([])
      this.calAmount()
    },
    // 删除选中宝贝
    handleBatchRemove () {
      if (this.selectedGoodsIds.length === 0) {
        this.$message.error('请选择要删除的商品')
        return
      }
      this.singleRemove = false
      this.showpop = true
    },
    // 单个删除
    handleSingleRemove (goods) {
      this.selectedGoodsIds = [goods.goodsTargetId]
      this.singleRemove = true
      goods.selected = true
      this.showpop = true
    },
    // 删除商品
    handleRemoveGoods (type, store) {
      let selectedSkuIds = []
      if (type === 'invalid') {
        let invalidList = this.inValidList
        if (store != null) {
          invalidList = [store]
        }
        invalidList.forEach(item => {
          item.goodsList.forEach(goods => {
            selectedSkuIds.push(goods.goodsTargetId)
          })
        })
        if (selectedSkuIds.length === 0) {
          this.$message.error('请选择商品')
          return
        }
      } else {
        selectedSkuIds = Array.from(new Set(this.selectedGoodsIds))
      }
      const formData = new FormData()
      formData.append('skuIds', selectedSkuIds)
      removeGoods(formData).then(res => {
        if (res.code === 0) {
          this.showpop = false
          this.$message.success('删除成功')
          this.loadList()
        } else {
          this.$message.error(res.error)
        }
      })
    },
    // 清空购物车
    handleRemoveCart () {
      removeCart().then(res => {
        if (res.code === 0) {
          this.$message.success('已全部删除购物车商品')
          this.loadList()
        } else {
          this.$message.error(res.error)
        }
      })
    },
    // 更新购物车
    updateCart (item) {
      const param = {
        goodsTargetId: item.goodsTargetId,
        moduleType: 'RETAIL',
        quantity: item.quantity
      }
      this.originSelectedStoreIds = this.selectedStoreIds
      this.originSelectedGoodsIds = this.selectedGoodsIds
      updateCart(param).then(res => {
        if (res.code === 0) {
          this.calAmount()
          this.loadList()
        } else {
          this.$message.error(res.error)
        }
      })
    },
    // 增加数量
    handleAddQty (goods) {
      goods.quantity += 1
      this.updateCart(goods)
    },
    // 减少数量
    handleDecQty (goods) {
      goods.quantity -= 1
      this.updateCart(goods)
    },
    // 计算
    calAmount () {
      const cartItemGroups = []
      this.totalNum = 0
      this.selectedGoodsIds = []
      // 数据整理，按店铺提交
      this.list.forEach(store => {
        store.goodsList.forEach(goods => {
          if (goods.selected) {
            this.totalNum += goods.quantity
            this.selectedGoodsIds.push(goods.goodsTargetId)
            const index = cartItemGroups.findIndex(item => item.storeId === store.industryId)
            if (index >= 0) {
              cartItemGroups[index].cartItems.push(goods.id)
            } else {
              cartItemGroups.push({
                storeId: store.industryId,
                cartItems: [goods.id]
              })
            }
          }
        })
      })
      if (cartItemGroups.length > 0) {
        const param = {
          cartItemGroups,
          merchId: config.MERCHID
        }
        calAmount(param).then(res => {
          if (res.code === 0) {
            this.totalAmount = res.data.amountPayable
          } else {
            this.$message.error(res.error)
          }
        })
      } else {
        this.totalAmount = 0
      }
    },
    // 立即购买
    handleToBuy () {
      const orderList = []
      this.list.forEach(item => {
        const goodsList = item.goodsList.filter(goods => goods.selected)
        if (goodsList.length > 0) {
          const orderInfo = {
            goodsList,
            industryName: item.industryName,
            industryId: item.industryId
          }
          orderList.push(orderInfo)
        }
      })
      let inValidGoods = []
      this.inValidList.forEach(item => {
        inValidGoods = inValidGoods.concat(item.goodsList.filter(goods => goods.selected))
      })
      if (inValidGoods.length > 0) {
        this.$message.error('失效商品不可购买')
        return
      }
      if (orderList.length === 0) {
        this.$message.error('请选择要购买的商品')
        return
      }
      if (orderList.length > 1) {
        this.$message.error('暂不允许跨店下单')
        return
      }
      localStorage.setItem('retailOrderList', JSON.stringify(orderList))
      this.$router.push({ path: 'retailOrderConfirm?from=cart' })
    }
  }
}
</script>
<style scoped lang='scss'>
.cart {
  .cart-wrap {
    max-width: 1279px;
    padding: 40px;
    overflow-x: auto;
    width: 1279px;
    background: #FFFFFF;
    box-shadow: 0px 3px 16px rgba(24, 60, 80, 0.08);
    border-radius: 8px;
    .title {
      margin-bottom: 40px;
      font-size: 24px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      line-height: 36px;
      color: #9B232A;
    }
  }

  .cart-info {
    .store-list {
      .store-item {
        .store-name {
          position: relative;
          padding-left: 18px;
          .el-checkbox {
            margin-right: 8px;
          }

          .remove-btn {
            position: absolute;
            right: 0;
            top: 0;
            cursor: pointer;
            color: #1890ff;
            font-weight: 400;
          }
        }

        .goods-list {
          .row {
            .row-item {
              .el-checkbox {
                margin-top: 30px;
                margin-right: 8px;
              }
              .qty {
                margin: 0 16px;
              }
              .control {
                width: 19px;
                height: 19px;
                vertical-align: middle;
                cursor: pointer;
                &.disabled {
                  cursor: not-allowed;
                }
              }

              .single-delete {
                font-size: 14px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #6A7792;
                cursor: pointer;
              }
            }
          }
        }
      }
    }

    .invalid-goods {
      margin-top: 40px;
      margin-bottom: 20px;
      font-size: 20px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      line-height: 26px;
      color: #242B34;
    }
  }

  .sum-info {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 60px;
    line-height: 60px;
    z-index: 99;
    background: #FFFFFF;
    box-shadow: 0px -3px 20px rgba(14, 78, 114, 0.08);
    .inner {
      display: flex;
      max-width: 1200px;
      margin: 0 auto;
      align-items: center;
      justify-content: space-between;
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #44516F;

      .a-btn {
        margin-left: 60px;
        cursor: pointer;
      }

      .right {
        .num {
          em {
            margin-left: 12px;
            margin-right: 8px;
            font-size: 16px;
            font-family: Source Han Sans CN;
            font-weight: bold;
            color: #FF0000;
            font-style: normal;
          }
        }

        .total {
          margin-left: 65px;
          font-size: 14px;
        }

        .amount {
          margin-right: 80px;
          margin-left: 12px;
          font-size: 16px;
          font-family: Source Han Sans CN;
          font-weight: bold;
          color: #FF0000;
          em {
            font-size: 28px;
            font-style: normal;
          }
        }
      }
    }
  }
}
</style>
